const MLS_ORGS = {
    BahamasMLS: {
        id: 878,
        name: 'BahamasMLS',
        defaultText: 'Courtesy of: The Bahamas MLS'
    },
};

export const BAHAMAS_MLS_ID = MLS_ORGS.BahamasMLS.id;

export const isSpecificMLS = (house, mlsKey) => {
    if (!house?.mlsOrg?.id) {
        return false; 
    }
    return house.mlsOrg.id === MLS_ORGS[mlsKey].id;
};

export const getTemplate = (house, officeStatus, templateKey = 'template') => {
    if (!house || !house.mlsOrg || !house.mlsOrg[templateKey]) {
        return ''; 
    }
    if (isSpecificMLS(house, 'BahamasMLS')) {
        return officeStatus ? house.mlsOrg[templateKey] : MLS_ORGS.BahamasMLS.defaultText;
    }
    return house.mlsOrg[templateKey];
}

/**
 * @param {*} listingManagementType - 10 is office type's value - hard code
 * @returns 
 */

export async function getOfficeStatus(listingIds, listingType, userId, listingManagementType = 10, axiosIns) {
    const axiosInstance = axiosIns || this.axiosIns;
    const res = await axiosInstance.post('/open-api/listing/mls/checkInOffice', {
        listingIds,
        soldFlag: listingType,
        listingManagementType,
        userId        
    });
    return res?.data || {};
}

export async function getHouseOfficeStatus(data, agentId) {
    if (!data?.listings) {
        return data; 
    }
    
    let list = data.listings || data.house || [];
    let listingIds = [];
    list.forEach(v => {
        if (v.mlsOrg?.id === BAHAMAS_MLS_ID) {
            listingIds.push(v.id); 
        }               
    });
    if (!listingIds.length) {
        return data; 
    }
    const isSold = typeof data.listingType == 'string' ? data.listingType?.toLowerCase() === 'sold-listing' : data.listingType;
    const res = await getOfficeStatus(
        listingIds,
        isSold,
        agentId,
        10,
        this.axiosIns
    );
    if (!res) {
        return data; 
    }

    data.listings.forEach(v => {
        if (listingIds.includes(v.id)) {
            v.isOfficeListed = res[v.id];
            v.mlsOrg.cardTemplate = getTemplate(v, res[v.id], 'cardTemplate');
            v.mlsOrg.template = getTemplate(v, res[v.id], 'template');
        }
    });
    return data;
}

/**
    * 1: above - show above the price
    * 2: under - show below the copy right part
    * 3: top - show right below the image 
*/
export const PROVIDED_POSITION_KEY = {
    above: 1,
    under: 2,
    top: 3
}

export const MLS_HIDE_SOLD_ESTIMATE_BLOCK = {
    reaVowMLS: {
        id: 588,
        name: 'REALTORS® Association of Edmonton (RAE VOW)',
    }
}

const MLS_HIDE_MAP_OBJ = new Map(
    Object.values(MLS_HIDE_SOLD_ESTIMATE_BLOCK).map(mls => [mls.id, mls])
);

export const isHideSoldEstimateBlock = (house) => {
    const mlsId = Number(house?.mlsOrg?.id);
    if (!mlsId || isNaN(mlsId)) {
        return false; 
    }
    return MLS_HIDE_MAP_OBJ.has(mlsId);
};

